let filterToQueryMixin = function(filterDefinition) {
  let defaultFilter = {};

  Object.keys(filterDefinition).forEach(key => {
    if (typeof filterDefinition[key] === "function") {
      filterDefinition[key] = {
        type: filterDefinition[key],
        defaultVal: null
      };
    }

    defaultFilter[key] = filterDefinition[key].defaultVal || null;
  });

  function cleanUrlQuery(query) {
    let filter = {};

    Object.keys(filterDefinition).forEach(key => {
      filter[key] = query[key];
    });

    return filter;
  }

  function urlQueryToFilter(query, filter = {}) {
    Object.keys(filterDefinition).forEach(key => {
      if (query[key] !== undefined) {
        switch (filterDefinition[key].type) {
          case Boolean:
            filter[key] = !!+query[key];
            break;
          case Number:
            filter[key] = Number(query[key]);
            break;
          case Array:
            filter[key] =
              typeof query[key] === "string" ? query[key].split(",") : [];
            break;
          default:
            filter[key] = query[key];
            break;
        }
      } else {
        filter[key] = null;
      }
    });

    return filter;
  }

  function filterToUrlQuery(filter = {}) {
    let query = {};

    Object.keys(filterDefinition).forEach(key => {
      if (filter[key] instanceof Array) {
        query[key] = filter[key].join(",");
      } else if (filter[key] !== undefined && filter[key] !== null) {
        if (filterDefinition[key].type === Boolean) {
          query[key] = +filter[key];
        } else {
          query[key] = String(filter[key]);
        }
      }

      if (query[key] == filterDefinition[key].defaultVal) {
        delete query[key];
      }
    });

    return Object.filterNull(query);
  }

  return {
    data() {
      return {
        filter: JSON.parse(JSON.stringify(defaultFilter)),
        currentPage: this.$route.query.page || 1
      };
    },
    watch: {
      filter: {
        handler(newValue) {
          let query = filterToUrlQuery(newValue);
          if (query.page != 1) {
            query.page = this.currentPage;
          }
          const urlQuery = Object.filterNull(cleanUrlQuery(this.$route.query));

          if (JSON.stringify(urlQuery) !== JSON.stringify(query)) {
            this.$router.replace({ query });
          }
        },
        deep: true
      },
      currentPage(page) {
        if (+this.$route.query.page === page) {
          return;
        }

        const query = Object.assign(
          filterToUrlQuery(urlQueryToFilter(this.$route.query)),
          {
            page
          }
        );
        if (page === 1) {
          delete query.page;
        }
        this.$router.replace({ query: Object.filterNull(query) });
      }
    },
    created() {
      const queryFilter = Object.filterNull(
        urlQueryToFilter(this.$route.query)
      );
      this.filter = JSON.parse(
        JSON.stringify(Object.assign(this.filter, queryFilter))
      );

      if (this.$route.query && this.$route.query.page) {
        this.currentPage = +this.$route.query.page;
      }
    },
    methods: {
      updateFilter(filter) {
        let query = filterToUrlQuery(filter);

        query.page = this.currentPage;
        const urlQuery = Object.filterNull(cleanUrlQuery(this.$route.query));

        if (JSON.stringify(urlQuery) === JSON.stringify(query)) {
          this.$router.replace({ query });
        }
      },
      resetFilter() {
        this.filter = JSON.parse(JSON.stringify(defaultFilter));
      }
    }
  };
};

export default filterToQueryMixin;
